<template>
  <div class="league-games-container">
    <el-form label-width="80px" >
      <el-form-item label="比赛周次" >
        <el-row>
          <el-select v-model="week" filterable value-key="name" @change="changeWeek" placeholder="请选择">
            <el-option
              v-for="item in weekList"
              :key="item.id"
              :label="item.name"
              :value="item">
            </el-option>
          </el-select>
          <el-button @click="weekDialogVisible = true" type="primary" plain>维护周次</el-button>
        </el-row>
      </el-form-item>
      <el-form-item label="阶段展示" >
        <el-button v-for="item in stageList" :key="item.id" v-show="!week.stageType || item.stageType == week.stageType" :class="{active:(item.isActive && item.id==stageId)}" @click="toggleStage(item)" >{{ item.name }}</el-button>
        <el-button @click="stagesDialogVisible = true" type="primary" plain>维护阶段</el-button>
      </el-form-item>
      <el-form-item label="比赛列表" >
        <el-button @click="matchDialogVisible = true" >添加比赛</el-button>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="listLoading"
      :data="matchList"
      style="width: 100%">
      <el-table-column
        label="场次"
        width="60"
        prop="seq">
      </el-table-column>
      <el-table-column
        :formatter="formatDate"
        width="180"
        prop="beginDate">
        <template slot="header" slot-scope="scope">
          <div>比赛时间</div>
          <el-date-picker
            v-model="search.beginDate"
            @change="getGameList"
            type="date"
            placeholder="选择日期" />
        </template>
      </el-table-column>
      <el-table-column
        prop="homeTeamName">
        <template slot="header" slot-scope="scope">
          <div>主队</div>
          <el-input v-model="search.homeTeamName" @change="getGameList" placeholder="关键字" ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="awayTeamName">
        <template slot="header" slot-scope="scope">
          <div>客队</div>
          <el-input v-model="search.awayTeamName" @change="getGameList" placeholder="关键字" ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="比分">
        <template slot-scope="scope" >
          {{ scope.row.homeScore<0?'-':scope.row.homeScore}} : {{ scope.row.awayScore<0?'-':scope.row.awayScore }}
        </template>
      </el-table-column>
      <el-table-column
        label="比赛ID">
        <template slot-scope="scope" >
          <label style="color:#487CC6;cursor:pointer;" @click="copy(scope.row.id, $event)">{{ scope.row.id }}</label>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="250"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="GetGame(scope.row.id)">编辑</el-button>
          <el-button
            size="mini"
            @click="goScores(scope.row.id)">成绩录入</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDeleteGame(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <!-- create/edit modal start -->
    <!-- 周次 -->
    <el-dialog
      :visible.sync="weekDialogVisible"
      title="维护周次信息">
      <div>
        <el-form label-width="96px" >
          <el-form-item label="周次数量" >
            <el-row>
              <el-input v-model="weeks.count"></el-input>
              <el-checkbox v-model="weeks.stageType">季后赛</el-checkbox>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-row>
              <el-button @click="createWeek" >生成周次</el-button>
            </el-row>
          </el-form-item>
        </el-form>
        <el-table
          :data="weekList"
          @row-click="onEdit"
          border
          class="create-week"
          style="width: 100%">
          <el-table-column
            label="序号"
            type="index">
          </el-table-column>
          <el-table-column
            label="名称"
            prop="name">
            <template slot-scope="scope" >
              <el-input v-if="scope.row.isEdit" v-model="scope.row.name" @keyup.enter.native="updateWeekInfo(scope.row)"></el-input>
              <label v-if="!scope.row.isEdit">{{scope.row.name}}</label>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="160">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="updateWeekInfo(scope.row)">保存</el-button>
              <el-button
                size="mini"
                type="danger"
                @click="deleteWeek(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="weekDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="weekDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 阶段 -->
    <el-dialog
      :visible.sync="stagesDialogVisible"
      title="维护阶段信息"
      width="50%">
      <div>
        <el-form label-width="96px" >
          <el-form-item label="阶段名称" >
            <el-row>
              <el-input v-model="stage.name"></el-input>
              <el-checkbox v-model="stage.stageType">季后赛</el-checkbox>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-row>
              <el-button @click="createStage" >保存</el-button>
            </el-row>
          </el-form-item>
        </el-form>
        <el-table
          :data="stageList"
          @row-click="onEdit"
          border
          class="create-week"
          style="width: 100%">
          <el-table-column
            label="序号"
            type="index">
          </el-table-column>
          <el-table-column
            label="名称"
            width="150"
            prop="name">
            <template slot-scope="scope" >
              <el-input v-if="scope.row.isEdit" v-model="scope.row.name" @change="updateStageInfo(scope.row)"></el-input>
              <label v-if="!scope.row.isEdit">{{scope.row.name}}</label>
            </template>
          </el-table-column>
          <el-table-column
            label="描述"
            prop="remark">
            <template slot-scope="scope" >
              <el-input v-if="scope.row.isEdit" v-model="scope.row.remark" @change="updateStageInfo(scope.row)"></el-input>
              <label v-if="!scope.row.isEdit">{{scope.row.remark}}</label>
            </template>
          </el-table-column>
          <el-table-column
            label="每局时间"
            prop="sectionDurationMinutes">
            <template slot-scope="scope" >
              <el-input v-if="scope.row.isEdit" v-model="scope.row.sectionDurationMinutes" @change="updateStageInfo(scope.row)"></el-input>
              <label v-if="!scope.row.isEdit">{{scope.row.sectionDurationMinutes}}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="85"
            label="排位赛">
            <template slot-scope="scope">
              <el-select v-model="scope.row.knockoutType" placeholder="请选择">
                <el-option
                  v-for="item in [{id: 1, name: '是'}, {id: 0, name: '否'}]"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="160">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="updateStageInfo(scope.row)">保存</el-button>
              <el-button
                size="mini"
                type="danger"
                @click="deleteStage(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="stagesDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="stagesDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 比赛 -->
    <el-dialog
      :visible.sync="matchDialogVisible"
      title="添加比赛信息"
      width="50%">
      <div>
        <el-form class="match-dialog-visible" label-width="96px" >
          <el-form-item label="选择周次" >
            <el-select v-model="match.week" filterable value-key="name" placeholder="请选择">
              <el-option
                v-for="item in weekList"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择阶段" >
            <el-select v-model="match.stage" filterable value-key="name" placeholder="请选择">
              <el-option
                v-for="item in stageList"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="比赛场地" >
            <el-row>
              <el-input v-model="match.venue"></el-input>
            </el-row>
          </el-form-item>
          <el-form-item class="match-date" label="比赛时间" >
            <el-date-picker
              v-model="match.beginDate"
              type="datetime"
              placeholder="选择开始日期">
            </el-date-picker>
          </el-date-picker>
          </el-form-item>
          <el-form-item label="比赛场次" >
            <el-row>
              <el-input v-model="match.seq"></el-input>
            </el-row>
          </el-form-item>
          <el-form-item label="加场" >
            <el-row>
              <el-input v-model="match.add"></el-input>
            </el-row>
          </el-form-item>
          <el-form-item label="选择主队" >
            <el-select v-model="match.homeTeamId" filterable value-key="name" placeholder="请选择">
              <el-option
                v-for="item in teamList"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择客队" >
            <el-select v-model="match.awayTeamId" filterable value-key="name" placeholder="请选择">
              <el-option
                v-for="item in teamList"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="matchDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="createGame">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 更新赛事 -->
    <el-dialog
      :visible.sync="updateMatchDialogVisible"
      title="更新比赛信息"
      width="50%">
      <div>
        <el-form class="match-dialog-visible" label-width="96px" >
          <el-form-item label="选择周次" >
            <el-select v-model="updateMatch.week" filterable value-key="name" placeholder="请选择">
              <el-option
                v-for="item in weekList"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择阶段" >
            <el-select v-model="updateMatch.stage" filterable value-key="name" placeholder="请选择">
              <el-option
                v-for="item in stageList"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="比赛场地" >
            <el-row>
              <el-input v-model="updateMatch.venue"></el-input>
            </el-row>
          </el-form-item>
          <el-form-item class="match-date" label="比赛时间" >
            <el-date-picker
              v-model="updateMatch.beginDate"
              type="datetime"
              placeholder="选择开始日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="比赛场次" >
            <el-row>
              <el-input v-model="updateMatch.seq"></el-input>
            </el-row>
          </el-form-item>
          <el-form-item label="加场" >
            <el-row>
              <el-input v-model="updateMatch.add"></el-input>
            </el-row>
          </el-form-item>
          <el-form-item label="选择主队" >
            <el-select v-model="updateMatch.homeTeam" filterable value-key="name" placeholder="请选择">
              <el-option
                v-for="item in teamList"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择客队" >
            <el-select v-model="updateMatch.awayTeam" filterable value-key="name" placeholder="请选择">
              <el-option
                v-for="item in teamList"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateMatchDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateGame">确 定</el-button>
      </span>
    </el-dialog>
    <!-- create/edit modal start -->

  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import { getDateObjectByString } from '@/utils'
import { createWeeks, getGroupWeekList, createStages, getGroupStageList, updateStage, updateWeek, deleteWeek, deleteStage, getMatchGroupTeamList,
  createGame, getGameList, GetGame, deleteGame, updateGame } from '@/api/match'

export default {
  name: 'LeagueGamesList',
  data() {
    return {
      isActive: true,
      isEdit: false,
      totalCount: 0, // 默认数据总数
      pageSize: 20, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      routerParams: {},
      week: {},
      weeks: {
        count: null,
        stageType: false
      },
      weekList: [],
      weekDialogVisible: false,
      stageId: null,
      stage: {
        name: null,
        stageType: false
      },
      stageList: [],
      stagesDialogVisible: false,
      match: {},
      matchList: [],
      matchDialogVisible: false,
      teamList: [],
      listLoading: false,
      search: {},
      updateInfo: false,
      updateMatchDialogVisible: false,
      updateMatch: {
        week: null,
        stage: null,
        venue: null,
        beginDate: null,
        endDate: null,
        seq: null,
        homeTeam: null,
        awayTeam: null
      }
    }
  },
  created() {
    this.routerParams = this.$route.params
    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page, 10)
    }
    this.getGroupWeekList()
    this.getGroupStageList()
    this.getGameList()
    this.getMatchGroupTeamList()
  },
  computed: {},
  methods: {
    copy(id, e) {
      try {
        navigator.clipboard.writeText(id);
        this.$message({ message: '比赛ID已复制', type: 'success', duration: 800 })
      } catch (err) {
        const range = document.createRange();
        range.selectNodeContents(e.currentTarget);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand('copy');
        this.$message({ message: '比赛ID已复制', type: 'success', duration: 800 })
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getGameList()
    },
    handleRolesChange() {},
    goScores(gameId) {
      this.$router.push({ name: 'LeagueGroupGameScore', params: { id: this.routerParams.id, gid: this.routerParams.gid, mid: gameId }})
    },
    goDetails() {
      this.$router.push({ name: 'LeagueGroupGameEdit', params: { id: 1, gid: 1, mid: 1 }})
    },
    onEdit (row, column, cell, event) {
      row.isEdit = true
    },
    createWeek() {
      let param = {
        groupId: this.routerParams.gid,
        count: this.weeks.count,
        stageType: this.weeks.stageType ? 1 : 0
      }
      createWeeks(param).then((res) => {
        const data = res.data
        if(data) {
          this.getGroupWeekList()
          this.$message({ message: '生成周次成功', type: 'success' })
        }
      })
    },
    getGroupWeekList() {
        getGroupWeekList({ groupId: this.routerParams.gid, pageSize: 9999 }).then(resolve => {
          this.weekList = []
          let data = resolve.data
          _.forEach(data.list, (item) => {
            item.isEdit = false
            this.weekList.push(item)
          })
      })
    },
    createStage() {
      let params = {
        groupId: this.routerParams.gid,
        names: JSON.stringify([this.stage.name]),
        stageType: this.stage.stageType ? 1 : 0
      }
      createStages(params).then((resolve) => {
        if (resolve) {
          this.getGroupStageList()
          this.$message({
            message: '阶段添加成功',
            type: 'success'
          })
        }
      })
    },
    getGroupStageList() {
      getGroupStageList({ groupId: this.routerParams.gid, stageType: this.week.stageType, pageSize: 9999 }).then((resolve) => {
        this.stageList = []
        const data = resolve.data
        _.forEach(data.list, (item) => {
          item.isEdit = false
          item.isActive = false
          this.stageList.push(item)
        })
      })
    },
    updateStageInfo(item) {
      let params = {
        id: item.id,
        name: item.name,
        sectionDurationMinutes: item.sectionDurationMinutes,
        knockoutType: item.knockoutType||0,
        remark: item.remark
      }
      updateStage(params).then((resolve) => {
        if (resolve && resolve.data) {
          item.isEdit = false
          this.$message({
            message: '阶段更新成功',
            type: 'success'
          })
        }
      })
    },
    updateWeekInfo(item) {
      let params = {
        id: item.id,
        name: item.name
      }
      updateWeek(params).then((resolve) => {
        if (resolve && resolve.data) {
          item.isEdit = false
          this.$message({
            message: '更新周次成功',
            type: 'success'
          })
        }
      })
    },
    deleteWeek(row) {
      deleteWeek({ id: row.id }).then((resolve) => {
        if (resolve && resolve.data) {
          this.getGroupWeekList()
          this.$message({
            message: '删除周次成功',
            type: 'success'
          })
        }
      })
    },
    deleteStage(id) {
      deleteStage({ id: id }).then((resolve) => {
        if (resolve && resolve.data) {
          this.getGroupStageList()
          this.$message({
            message: '删除阶段成功',
            type: 'success'
          })
        }
      })
    },
    getMatchGroupTeamList() {
      getMatchGroupTeamList({ auditStatus:2, groupId: this.routerParams.gid, pageSize: 9999 }).then((resolve) => {
        this.teamList = resolve.data.list
      })
    },
    createGame() {
      // 这个地方需要验证form表达是否不为空，不为空在开始负值
      let params = {
        stageId: this.match.stage.id,
        weekId: this.match.week.id,
        venue: this.match.venue,
        seq: this.match.seq,
        homeTeamId: this.match.homeTeamId.id,
        awayTeamId: this.match.awayTeamId.id
      }
      if (this.match.beginDate) {
        params.beginDate = moment(this.match.beginDate).format('YYYY-MM-DDTHH:mm:ss+0800')
      }
      createGame(params).then((resolve) => {
        if (resolve && resolve.data) {
          this.$message({
            message: '比赛添加成功',
            type: 'success'
          })
          this.matchDialogVisible = false
          this.getGameList()
        }
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.$router.push({path: this.$route.path, query: {page: val}})
      this.getGameList()
    },
    quickSearch() {
      this.getGameList()
    },
    changeWeek() {
      this.stageId = ''
      this.currentPage = 1
      this.$router.push({path: this.$route.path, query: {page: 1}})
      this.getGroupStageList()
      this.getGameList()
    },
    getGameList() {
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        groupId: this.routerParams.gid,
        stageId: this.stageId,
        weekId: this.week.id
      }
      if (this.search.beginDate) {
        this.search.beginDate = moment(this.search.beginDate).format('YYYY-MM-DD')
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      getGameList(this.listQuery).then((resolve) => {
        const data = resolve.data
        this.listLoading = false
        if(data) {
          this.matchList = data.list
          this.currentPage = data.pageNum
          this.totalCount = data.count
        }
      })
    },
    toggleStage(stage) {
      if(this.stageId == stage.id) {
        if(stage.isActive) {
          this.stageId = ''
        }
        stage.isActive = !stage.isActive
      } else {
        stage.isActive = true
        this.stageId = stage.id
      }
//      if(stage.isActive) {
//        stage.isActive = false
//        this.stageId = ''
//      } else {
//        stage.isActive = true
//        this.stageId = stage.id
//      }
      this.getGameList()
    },
    formatDate: function(row, column) {
      const date = row[column.property]
      return date && moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    GetGame(id) {
      this.updateMatchDialogVisible = true
      GetGame({ id: id }).then((resolve) => {
        let game = resolve.data.game
        this.updateMatch.venue = game.venue
        this.updateMatch.seq = game.seq
        this.updateMatch.beginDate = getDateObjectByString(game.beginDate)
        this.updateMatch.endDate = getDateObjectByString(game.endDate)
        this.updateMatch.id = id
        this.weekList.filter((item) => {
          if (game.weekId === item.id) {
            this.updateMatch.week = item
          }
        })
        this.stageList.filter((item) => {
          if (game.stageId === item.id) {
            this.updateMatch.stage = item
          }
        })
        this.teamList.filter((item) => {
          if (game.homeTeamId === item.id) {
            this.updateMatch.homeTeam = item
          } else if (game.awayTeamId === item.id) {
            this.updateMatch.awayTeam = item
          }
        })
      })
    },
    handleDeleteGame(id) {
      this.$confirm('此操作将永久删除该比赛, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteGame(id)
      }).catch(() => {
      })
    },
    deleteGame(id) {
      deleteGame({ id: id }).then((resolve) => {
        if (resolve) {
          this.getGameList()
          this.$message({
            message: '比赛删除成功',
            type: 'success'
          })
        }
      })
    },
    updateGame() {
      let params = {
        id: this.updateMatch.id,
        stageId: this.updateMatch.stage.id,
        weekId: this.updateMatch.week.id,
        venue: this.updateMatch.venue,
        seq: this.updateMatch.seq,
        homeTeamId: this.updateMatch.homeTeam.id,
        awayTeamId: this.updateMatch.awayTeam.id
      }
      if (this.updateMatch.beginDate) {
        params.beginDate = moment(this.updateMatch.beginDate).format('YYYY-MM-DDTHH:mm:ss+0800')
      }
      updateGame(params).then((resolve) => {
        if (resolve && resolve.data) {
          this.updateMatchDialogVisible = false
          this.$message({
            message: '比赛更新成功',
            type: 'success'
          })
          this.getGameList()
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .league-games-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }

    .el-date-editor.el-input {
      width: 140px;
    }

    .el-input__prefix {
      left: 10px
    }

    .el-input__suffix {
      right: 10px;
    }

    .el-input--prefix .el-input__inner {
      padding-left: 30px;
      padding-right: 20px;
    }

    .demonstration {
      display: block;
      padding-bottom: 15px;
    }

    .input-win {
      width: 200px !important;
    }

    .input-win .el-input__prefix {
      left: 5px;
    }

    .el-form {
      .el-input {
        width: auto;
      }
    }

    .active {
      color: #fff;
      background-color: #67c23a;
      border-color: #67c23a;
    }

  }
</style>
